import { Link } from 'react-router-dom';
import React from 'react';
import Typography from 'kingpin/atoms/Typography';
import Row from '../../components/Common/Row';
import appRoutes from '../../navigation/appRoutes';
import { ReactComponent as Dot } from './dot.svg';

const AuthLinks = () => (
  <Row centerAlign style={{ justifyContent: 'center', gap: '8px' }}>
    <Link to={appRoutes.wallboardSetup}>
      <Typography.Body type="Body 14">Access Wallboard</Typography.Body>
    </Link>
    <Dot />
    <Link to={appRoutes.forgotPassword}>
      <Typography.Body type="Body 14">I forgot my password</Typography.Body>
    </Link>
  </Row>
);

export default AuthLinks;
